import { c as _c } from "react/compiler-runtime";
import cn from 'classnames';
import styles from './index.module.scss';
type AdsGAMPlacementProps = {
  id: string;
  classes?: Array<string>;
  fixedHeight?: number;
  displayPlaceholder?: boolean;
};

/**
 * This component adds a wrapper to the div of the adUnit.
 * This wrapper has the role of "sandbox" because avoid too tall banners, when a
 * `fixedHeight` is provided.
 * The `fixedHeight` can be used for the placements above the fold to avoid
 * CLS issues.
 * It also fixes the centering of the creative.
 */
const AdsGAMPlacement = t0 => {
  const $ = _c(17);
  const {
    id,
    classes,
    fixedHeight,
    displayPlaceholder
  } = t0;
  let t1;
  if ($[0] !== classes || $[1] !== displayPlaceholder || $[2] !== fixedHeight) {
    t1 = cn(styles["gam-sandbox"], classes, {
      [styles["gam-sandbox--overflow-h"]]: fixedHeight,
      [styles["gam-sandbox--with-placeholder"]]: displayPlaceholder
    });
    $[0] = classes;
    $[1] = displayPlaceholder;
    $[2] = fixedHeight;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== fixedHeight) {
    t2 = fixedHeight ? {
      height: `${fixedHeight}px`
    } : {};
    $[4] = fixedHeight;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== displayPlaceholder) {
    t3 = displayPlaceholder ? {
      backgroundImage: `url('${process.env.NEXT_PUBLIC_ASSETS_BASE_URL}/static/reclame/reclame-logo.webp')`
    } : {};
    $[6] = displayPlaceholder;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = {
      ...t2,
      ...t3
    };
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== id) {
    t5 = <div id={id} />;
    $[11] = id;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t1 || $[14] !== t4 || $[15] !== t5) {
    t6 = <div className={t1} style={t4}>{t5}</div>;
    $[13] = t1;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};
export { AdsGAMPlacement };